/**
 * Frontend helper for product-wise putaway.
 * buildSplitRows(remainingQuantity, qtyPerBin) => [{ qty }, ...]
 * - full rows = qtyPerBin, last row = remainder (ceil behavior).
 * - e.g. 1029 / 50 => 20 rows of 50 + 1 row of 29
 */
export function buildSplitRows(remainingQuantity, qtyPerBin) {
  const remaining = Number(remainingQuantity) || 0;
  const perBin = Number(qtyPerBin) || 0;
  if (remaining <= 0 || perBin <= 0) return [];
  const fullCount = Math.floor(remaining / perBin);
  const remainderQty = remaining % perBin;
  const rows = [];
  for (let i = 0; i < fullCount; i++) {
    rows.push({ qty: perBin });
  }
  if (remainderQty > 0) {
    rows.push({ qty: remainderQty });
  }
  return rows;
}

/**
 * suggestedBins = Math.ceil(remainingQuantity / qtyPerBin)
 */
export function getSuggestedBins(remainingQuantity, qtyPerBin) {
  const remaining = Number(remainingQuantity) || 0;
  const perBin = Number(qtyPerBin) || 1;
  if (perBin <= 0) return 0;
  return Math.ceil(remaining / perBin);
}
